import actionCreatorFactory from "typescript-fsa";
import { Action, Dispatch } from "redux";
import RoomApi from "api/RoomApi";
import RoomRes from "types/res/room/RoomRes";
import UpdateRoomReq from "types/req/room/UpdateRoomReq";
import CreateRoomReq from "types/req/room/CreateRoomReq";
import DeleteRoomReq from "types/req/room/DeleteRoomReq";

const actionCreator = actionCreatorFactory();

const addRoomAction = actionCreator.async<
  CreateRoomReq,
  RoomRes,
  { code: number; description: string }
>("ADD_ROOM");

export const addRoom =
  (companyId: number, req: CreateRoomReq) =>
  async (dispatch: Dispatch<Action>) => {
    dispatch(addRoomAction.started({ ...req }));
    try {
      const room = new CreateRoomReq({ ...req });
      const result = await RoomApi.create(companyId, room);
      dispatch(
        addRoomAction.done({ params: { ...req }, result: result as any })
      );
      return result;
    } catch (error) {
      dispatch(
        addRoomAction.failed({
          params: { ...req },
          // @ts-ignore
          error: { code: error.code, description: error.description },
        })
      );
      return error;
    }
  };

const fetchRoomAction = actionCreator.async<
  {},
  RoomRes[],
  { code: number; description: string }
>("FETCH_ROOM");

export const fetchRoom =
  (companyId: number) => async (dispatch: Dispatch<Action>) => {
    dispatch(fetchRoomAction.started([]));
    try {
      const result = await RoomApi.findAll(companyId);
      dispatch(
        fetchRoomAction.done({ params: {}, result: result as any })
      );
      return result;
    } catch (error) {
      dispatch(
        fetchRoomAction.failed({
          params: {},
          // @ts-ignore
          error: { code: error.code, description: error.description },
        })
      );
      return error;
    }
  };

const updateRoomAction = actionCreator.async<
  UpdateRoomReq,
  RoomRes,
  { code: number; description: string }
>("UPDATE_ROOM");

export const updateRoom =
  (companyId: number, req: UpdateRoomReq) =>
  async (dispatch: Dispatch<Action>) => {
    dispatch(updateRoomAction.started({ ...req }));
    try {
      const updateReq = new UpdateRoomReq({ ...req });
      const result = await RoomApi.update(companyId, updateReq);
      dispatch(
        updateRoomAction.done({ params: { ...req }, result: result as any })
      );
      return result;
    } catch (error) {
      dispatch(
        updateRoomAction.failed({
          params: { ...req },
          // @ts-ignore
          error: { code: error.code, description: error.description },
        })
      );
      return error;
    }
  };

const deleteRoomAction = actionCreator.async<
  DeleteRoomReq,
  {},
  { code: number; description: string }
>("DELETE_ROOM");

export const deleteRoom =
  (companyId: number, req: DeleteRoomReq) =>
  async (dispatch: Dispatch<Action>) => {
    dispatch(deleteRoomAction.started({ ...req }));
    try {
      const room = new DeleteRoomReq({ ...req });
      const result = await RoomApi.delete(companyId, room);
      dispatch(
        deleteRoomAction.done({ params: { ...req }, result: {} })
      );
      return result;
    } catch (error) {
      dispatch(
        deleteRoomAction.failed({
          params: { ...req },
          // @ts-ignore
          error: { code: error.code, description: error.description },
        })
      );
      return error;
    }
  };

const roomActions = {
  fetchRoomAction,
  addRoomAction,
  updateRoomAction,
  deleteRoomAction,
};

export default roomActions;
